module.exports = __webpack_public_path__ + "static/media/logoTxt.f70b24ce.svg";